<h1>Variables</h1>
<ul>
  @for (variable of getPossibleVariableNames(); track variable) {
    <li>
      <input
        type="checkbox"
        [(ngModel)]="isVariableSelected[variable]"
        (ngModelChange)="updateVariableSelection(variable)"
        />
      {{ variable }} ({{ possibleVariables[variable].getQualifiedName() }})
    </li>
  }
</ul>

<h1>Used</h1>
<ul cdkDropList (cdkDropListDropped)="sortUsedElements($event)">
  @for (element of getFormControlElements(); track element; let index = $index) {
    <li
      #usedList
      cdkDrag
      [cdkDragData]="element"
      >
      <button mat-icon-button (click)="removeElement(element, index)">
        <mat-icon>delete</mat-icon>
      </button>
      <span> {{ element.variable }}.{{ element.bindingPropertyName }} </span>
    </li>
  }
</ul>

<h1>Available</h1>
<ul #availableList>
  @for (element of availableElements; track element; let index = $index) {
    <li
      cdkFocusInitial
      >
      <button mat-icon-button (click)="addElement(element, index)">
        <mat-icon>add_circle_outline</mat-icon>
      </button>
      <span [style.color]="element.usageCount ? 'lightgray' : 'black'">
        {{ element.variable }}.{{ element.bindingPropertyName }} ({{
        element.usageCount
        }})
      </span>
    </li>
  }
</ul>

<!-- <button [mat-dialog-close]="form">Return</button> -->
